import React, { useState } from 'react';

const PopoverContext = React.createContext({});

function Popover({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <PopoverContext.Provider value={{ isOpen, setIsOpen }}>
      <div className="relative">
        {children}
      </div>
    </PopoverContext.Provider>
  );
}

function PopoverTrigger({ children, asChild = false }) {
  const { isOpen, setIsOpen } = React.useContext(PopoverContext);
  
  const trigger = React.cloneElement(
    asChild ? React.Children.only(children) : <button>{children}</button>,
    {
      onClick: () => setIsOpen(!isOpen),
      'aria-expanded': isOpen,
      'aria-haspopup': true
    }
  );

  return trigger;
}

function PopoverContent({ children, className = '' }) {
  const { isOpen } = React.useContext(PopoverContext);

  if (!isOpen) return null;

  return (
    <div className={`absolute z-50 mt-2 ${className}`}>
      {children}
    </div>
  );
}

export { Popover, PopoverTrigger, PopoverContent };